export default __webpack_public_path__ + "static/media/service2.92691d40.jpg";